const BASE_API = process.env.MIX_ENDLESS_API_URL

const state ={
	universityList:[],
	universityListData:[],
	universityListMeta:[],
	university:[],
	universityById:'',
	campusCourses:[],
	course:'',
	accommodations:[],
	courseSubjects:[],
	nearPlaces:[],
	universityListError:null,
	universityCoursesError:null,
	universityAccommodationsError:null
}
const getters = {
	universityListGetter:({universityListList}) => universityListList,
	universityListMetaGetter:({universityListMeta}) => universityListMeta,
	universityListDataGetter:({universityListData}) => universityListData,
	universityByIdGetter:({universityById}) => universityById,
	campusCoursesGetter:({campusCourses}) => campusCourses,
	courseGetter:({course}) => course,
	accommodationsGetter:({accommodations}) => accommodations,
	courseSubjectsGetter:({courseSubjects}) => courseSubjects,
	nearPlacesGetter:({nearPlaces}) => nearPlaces,
}
const mutations = {
	setUniversityListList : (state,payload)=> {
		state.universityListList = payload
	},
	setUniversityListMeta : (state,payload)=> state.universityListMeta = payload,
	setUniversityListSeeMore : (state,payload)=> state.universityListData.push(...payload),
	setEmptyUniversityListData : (state,payload)=> state.universityListData = [],
	setUniversityById: (state,payload)=> state.universityById = payload,
	setCampusCourses : (state,payload)=> state.campusCourses = payload,
	setCourse:(state,payload) => state.course = payload,
	setNearPlaces:(state,payload) => state.nearPlaces = payload,
	setAccommodations : (state,payload)=> state.accommodations = payload,
	setCourseSubjects : (state,payload)=> state.courseSubjects = payload,
	setFavorite:(state,payload) => {
		const findSchool = state.universityList.find(school => school.id === payload.campus_id)
		findSchool.is_favorite = payload.favorite
	},
	setFavoriteDetail:(state,payload) => {
		state.universityById.campus.is_favorite = payload.favorite
	},
}

const actions = {
	async getUniversityList({commit,state}, payload){
		await this.$axios.get(`${BASE_API}/campuses`,{params:{...payload.filters},headers:{...payload.headers}}).then(res => {
			commit('setUniversityList',res.data.result.data)
			commit('setUniversityListMeta',res.data.result.meta)
		}).catch(err => state.universityListError = err.response.status)
	},
	async getUniversityById({commit}, payload){
		var params = {place_id: payload.placeId}
		await this.$axios.get(`${BASE_API}/campuses/${payload.slug}`,{params: params}).then(res => {

			console.log('UniversityById',res.data.result)
			commit('setUniversityById',res.data.result)
		}).catch(err => state.universityListError = err.response.status)
	},
	async getNearPlaces({commit}, payload){
		var params={
			lat:payload.lat,
			lng:payload.lng,
		}
		await this.$axios.get(`${BASE_API}/nearby-places`,{params}).then(res => {
			console.log('setNearPlaces',res.data.result)
			commit('setNearPlaces',res.data.result)
		})
	},
	async getCampusCourses({commit}, payload){
		var params = {...payload.filters, place_id: payload.placeId}
		commit('setCampusCourses',[])
		if(payload.headers['accept-school-type']) {
			this.$axios.defaults.headers['Accept-School-Type'] = payload.headers['accept-school-type']
		}
		await this.$axios.get(`${BASE_API}/campuses/${payload.slug}/courses`,{params: params}).then(res => {
			commit('setCampusCourses', res.data.result)
			console.log('setCampusCourses', res.data.result)
		}).catch(err => state.universityCoursesError = err.response.status)
	},
	async getCourse({commit}, payload){
		if(payload.headers['accept-school-type']) {
			this.$axios.defaults.headers['Accept-School-Type'] = payload.headers['accept-school-type']
		}
		await this.$axios.get(`${BASE_API}/courses/${payload.courseId}`).then(res => {
			commit('setCourse', res.data.result)
		}).catch(err => state.universityListError = err.response.status)
	},
	async getAccommodations({commit}, payload){
		var params = {...payload.params, place_id: payload.placeId}
		await this.$axios.get(`${BASE_API}/campuses/${payload.slug}/accommodations`, {params: params}).then(res => {
			commit('setAccommodations', res.data.result)
		}).catch(err => state.universityAccommodationsError = err.response.status)
	},
	async getCourseSubjects({commit}, payload){
		var params = {place_id: payload.placeId}
		await this.$axios.get(`${BASE_API}/campuses/${payload.slug}/course-subjects`, {params: params}).then(res => {
			this.courseSubjects = res.data.result.data
			commit('setCourseSubjects', res.data.result.data)
		}).catch(err => state.universityListError = err.response.status)
	},
}

export default {namespaced:true,state,getters,mutations,actions}
